// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const SUPABASE_PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID as string | undefined;
export const PROD_PROJECT_ID = 'crbcveltedndupnkxuwn';
export const DEV_PROJECT_ID  = 'jodanrwzqdibjnpgoxmz';

// ── Safety guards ──────────────────────────────────────────────────────────────
// Guard 1: DEV build → PROD database (highest risk — data corruption)
if (import.meta.env.DEV && SUPABASE_PROJECT_ID === PROD_PROJECT_ID) {
  throw new Error(
    '⛔ Dev build is pointing at the PRODUCTION Supabase project. ' +
    'Check your .env file — VITE_SUPABASE_PROJECT_ID should be the dev project ID (' + DEV_PROJECT_ID + ').',
  );
}

// Guard 2: PROD build → DEV database (lower risk but still bad — live users see dev data)
if (import.meta.env.PROD && SUPABASE_PROJECT_ID === DEV_PROJECT_ID) {
  // eslint-disable-next-line no-console
  console.error(
    '⚠️ Production build is pointing at the DEV Supabase project (' + DEV_PROJECT_ID + '). ' +
    'Check Vercel environment variables — VITE_SUPABASE_PROJECT_ID should be the prod project ID.',
  );
}

// Guard 3: Unknown project ID (typo or missing .env)
if (!SUPABASE_PROJECT_ID) {
  // eslint-disable-next-line no-console
  console.warn('⚠️ VITE_SUPABASE_PROJECT_ID is not set. Cannot verify database environment.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Bypass the Web Locks API — prevents signInWithPassword from waiting
    // indefinitely for a lock held by a slow/pending getSession() call.
    lock: (_name, _acquireTimeout, fn) => fn(),
  },
});